import * as React from 'react';
import Page from '../containers/Page';
import TasksList  from '../containers/TasksList';
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import PageWrapper from '../containers/PageWrapper';
import Kanban from '../containers/Kanban';

const ProjectPage = ({kanban}) =>{ 
    
    let { projectId } = useParams();

    return  (kanban ?
        <PageWrapper title="Kanban">
              <Kanban projectId={projectId} />
          </PageWrapper>:
        <Page title="Project" projectId={projectId}>
        <TasksList projectId={projectId} />
    </Page>
)}

const mapStateToProps = state => {

    return {
      kanban: state.kanban
    };
  };
  
  export default connect(mapStateToProps)(ProjectPage);